import React from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { PrivateRoute } from 'lib/core/components'
import { Dashboard } from './scenes/Dashboard'
import { ReportChart } from './scenes/ReportChart'

export const Community = () => {
  return (
    <Switch>
      <PrivateRoute
        exact
        path='/customer/account/community/report/:id'
        component={ReportChart}
      />

      <PrivateRoute
        exact
        path='/customer/account/community'
        component={Dashboard}
      />

      <Redirect
        to='/customer/account/community'
      />
    </Switch>
  )
}
